import { useNavigate, useSearchParams } from "react-router-dom";
import { Store } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Done() {
  const nav = useNavigate();
  const { t } = useI18n();
  const n = Number(useSearchParams()[0].get("n") || 1);
  return (
    <div data-testid="payment-result-store" className="max-w-md mx-auto px-6 py-20 flex flex-col items-center text-center gap-4 mn-rise">
      <div className="w-24 h-24 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center"><Store size={44} color="var(--brand-primary)" /></div>
      <h1 data-testid="payment-result-title" className="text-3xl font-extrabold">{n > 1 ? t("pr_confirmed_n", { n }) : t("pr_confirmed")}</h1>
      <p className="text-[var(--text-2)]">{t("pr_store_sub")}</p>
      <div className="flex flex-col gap-3 w-full mt-4">
        <button data-testid="go-bookings-button" className="mn-btn" onClick={() => nav("/prenotazioni", { replace: true })}>{t("go_bookings")}</button>
        <button data-testid="go-home-button" className="mn-btn mn-btn-ghost" onClick={() => nav("/", { replace: true })}>{t("back_to_bikes")}</button>
      </div>
    </div>
  );
}
